import { Component, Input } from '@angular/core';

/** Skeleton of the results page: filter panel, toolbar and flight cards, in the same shapes as the real thing. */
@Component({
    selector: 'app-results-loader',
    templateUrl: './results-loader.component.html',
    styleUrls: ['./results-loader.component.css'],
    standalone: false
})
export class ResultsLoaderComponent {
  /** Legs per card: 1 for one way, 2 for round trips. */
  @Input() legs = 1;

  readonly cards = [0, 1, 2, 3];
  readonly filterGroups = [3, 4, 4];

  get legSlots(): number[] {
    return Array.from({ length: Math.max(1, this.legs) }, (_, i) => i);
  }

  rows(count: number): number[] {
    return Array.from({ length: count }, (_, i) => i);
  }
}
